import { defineMessages } from "react-intl";

export default defineMessages({
  comparison: {
    id: "comparison",
    defaultMessage: "Comparison"
  },
});